import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarFrontView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCarFrontView"><Path d="M2.5 19.5V10.5L6.5 4.5H17.5L21.5 10.5V19.5H17.5V17.5H6.5V19.5H2.5Z" stroke="currentColor"/><Path d="M1 10.5H2.5" stroke="currentColor"/><Path d="M21.5 10.5H23" stroke="currentColor"/><Path d="M5 13.5H8" stroke="currentColor"/><Path d="M16 13.5H19" stroke="currentColor"/></CentralIconBase>;
});

export default IconCarFrontView;
